import styled from 'styled-components'


export const FreeFundComp = styled.div`
    opacity: 1;
    background-image: url("https://previews.123rf.com/images/lovender/lovender1801/lovender180100025/93767796-square-pattern-vector-seamless-background-green-rounded-squares-on-white-backdrop.jpg");
    /* background-size: 100%; */
    background-attachment: fixed;
    /* height: 50vh; */

`
 export const Container = styled.div`
    background-image: linear-gradient(to right, #54b98f, #1b8c78);
    opacity: 0.8;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding: 3em 1em;
    z-index: 1;
    `